import React,{ useState, useCallback } from 'react';
import styled from '@emotion/styled';

import LinkItem from "../../../components/LinkItem";

import { useLocalization } from "gatsby-theme-i18n";
import IconPackage from 'xiv-fanfes-2021'
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { parseHTML } from '../../../functions/common'

const Art = ({item, path, onClick}) => {
  const { t } = useLocalization();
  
  const [ isCopied, setIsCopied] = useState(false);
  const [ isHiding, setIsHiding] = useState(false);

  const copy = useCallback(() => {
    setIsCopied(true);

    setTimeout(() => {
      setIsHiding(true);
    },700)
    setTimeout(() => {
      setIsCopied(false);
      setIsHiding(false);
    },2500)

  },[setIsCopied,setIsHiding])
  return (
    <Item>
      
      {(item.number && path === 'fan-art-contest') &&
        <CopyToClipboard text={item.number} onCopy={copy}>
          <CopyLabel href={item.images.origin.url} 
            className={`${isCopied ? 'copied' : ''} ${isHiding ? 'hide' : ''}`} 
            onClick={(e) => {e.preventDefault()}}
            onMouseEnter={(e) => {
              setIsCopied(false);
              setIsHiding(false);
            }}
          >
            <IconPackage.Icon type={"Copy"} />{`${t('fan_art_contest.art.number.prefix')}${item.number}`}
            <CopyTooltip>
              <span className="copy">{t('fan_art_contest.art.number.tooltip.copy.label')}</span>
              <span className="copied">{t('fan_art_contest.art.number.tooltip.copied.label')}</span>
            </CopyTooltip>
          </CopyLabel>
        </CopyToClipboard>
      }
      
      <Frame href={item.images.origin.url} onClick={onClick}>
        {(item.fav && item.fav.team !== "") &&
          <FavouriteLabel>
            <Tooltip>{t(`fan_art_contest.contest.team.${item.fav.team}.favourite`)}</Tooltip>
            <IconPackage.Icon type={"Favourite"} color={'#D00F31'} />
          </FavouriteLabel>
        }
        <img src={item.images.thumb.url} className={item.images.thumb.height > item.images.thumb.width ? 'vertical' : 'horizontal'} width={item.images.thumb.width} heght={item.images.thumb.height} alt={`${t('fan_art_contest.art.number.prefix')}${item.number} ${item.title} / ${item.nickname} `}/>
      </Frame>
      <TitleLabel>{parseHTML(item.title)}</TitleLabel>
      <NameLabel>{parseHTML(item.nickname)}</NameLabel>
    </Item>
  );
}
 
export default Art;



const CopyLabel = styled(LinkItem)`
  font-weight: 900;
  font-size: 20px;
  line-height: 32px;
  color: #F50057;
  margin-bottom:8px;
  display:inline-block;
  vertical-align:middle;
  text-decoration:none;
  z-index:2;
  position:relative;

  svg{
    width:20px;
    height:20px;
    color:#CACACD;
    margin:0px 16px 6px 0px;
    vertical-align:middle;
  }

  &:hover{
    color: #FF186A;
    text-decoration:underline;
    svg{color:#FF186A;}
  }
  &:active{
    color: #D7004C;
    text-decoration:underline;
    svg{color:#D7004C;}
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin-bottom:8px;
    font-size: 16px;
    line-height: 24px;
    svg{
      width:16px;
      height:16px;
      margin:0px 12px 4px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-bottom:4px;
    font-size: 14px;
    line-height: 24px;
    svg{
      width:16px;
      height:16px;
      margin:0px 8px 4px;
    }
  }
`


const Item = styled.div`
  display:block;
  text-align:right;
  position:relative;

`

const Frame = styled(LinkItem)`
  transition: transform .1s ease-in-out;
  display:flex;
  background: #FCFCFF;
  /* Shadow / 1dp */

  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  padding-top:100%;
  width:100%;
  position:relative;

  &:hover {
    transform: scale(1.05);
    background: #FFF;
    box-shadow: 0px 6px 4px -4px rgba(0, 0, 0, 0.1), 0px 12px 8px -8px rgba(0, 0, 0, 0.05), 0px 24px 16px -16px rgba(0, 0, 0, 0.05);
  }

  > img{
    position:absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);

    &.horizontal{
      max-width: calc(100% - 64px);
      height: auto;
      width:calc(100% - 64px);
    }
    &.vertical{
      width: auto;
      max-height: calc(100% - 64px);
      height:calc(100% - 64px);
    }
  }
  
`

const TitleLabel = styled.div`
  margin-top:16px;
  font-weight: 900;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.03em;
  text-indent: 0.03em;
  color: #444448;
  text-align:center;

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin-top:12px;
    font-size: 16px;
    line-height: 28px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-top:8px;
    font-size: 14px;
    line-height: 24px;
  }
`

const NameLabel = styled.div`
  font-weight: normal;
  font-size: 16px;
  line-height: 28px;
  color: #787880;
  text-align:center;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 14px;
    line-height: 24px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 20px;
  }
`

const CopyTooltip = styled.span`
  display:block;
  background: rgba(44, 44, 46, 0.9);
  border-radius: 12px;
  padding:4px 16px;
  color:#FFFFFF;
  position: absolute;
  font-weight:bold;
  white-space:nowrap;
  font-size: 11px;
  line-height: 16px;
  bottom:100%;
  left:50%;
  transform:translateX(-50%);
  opacity:0;
  transition: opacity .3s;

  a:hover &{
    opacity:1;
  }

  a.copied &{
    opacity:1;
  
  }

  a.hide &{
    opacity:0;
  }
`

const Tooltip = styled.span`
  display:block;
  background: rgba(44, 44, 46, 0.9);
  border-radius: 12px;
  padding:4px 16px;
  color:#FFFFFF;
  position: absolute;
  font-weight:bold;
  white-space:nowrap;
  font-size: 11px;
  line-height: 16px;
  bottom:100%;
  left:50%;
  transform:translateX(-50%);
  opacity:0;
  transition: opacity .3s;
  .copy{display:block;}
  .copied{display:none;}

  a:hover &{
    opacity:1;
  }

  a.copied &{
    opacity:1;
    .copy{display:none;}
    .copied{display:block;}  
  
  }

  a.hide &{
    opacity:0;
  }
`

const FavouriteLabel = styled.div`
  text-align:right;
  line-height: 24px;
  position:absolute;
  top:0;
  z-index:10;
  right:4px;
  width:24px;
  height:24px;
  span{
    right: 0;
    left: auto;
    transform: none;
    bottom:calc(100% + 4px);
  }
  svg{
    width:24px;
    height:24px;
    display:block;
    margin:0;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    span{
      font-size: 12px;
      line-height: 20px;
    }
  }
`
